export const Users = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11.97 23.2197C6.04997 23.2197 1.21997 18.3997 1.21997 12.4697C1.21997 6.53973 6.04997 1.71973 11.97 1.71973C17.89 1.71973 22.72 6.53973 22.72 12.4697C22.72 18.3997 17.9 23.2197 11.97 23.2197ZM11.97 3.21973C6.86997 3.21973 2.71997 7.36973 2.71997 12.4697C2.71997 17.5697 6.86997 21.7197 11.97 21.7197C17.07 21.7197 21.22 17.5697 21.22 12.4697C21.22 7.36973 17.07 3.21973 11.97 3.21973Z" />
    <path d="M12 19.7196C9.85 19.7196 7.83 18.6696 6.6 16.8996C6.36 16.5596 6.45 16.0896 6.79 15.8596C7.13 15.6196 7.6 15.7096 7.83 16.0496C8.78 17.4096 10.34 18.2296 12 18.2296C13.66 18.2296 15.22 17.4196 16.17 16.0496C16.41 15.7096 16.87 15.6296 17.21 15.8596C17.55 16.0996 17.63 16.5596 17.4 16.8996C16.17 18.6696 14.15 19.7196 12 19.7196Z" />
  </svg>
);
